const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
const HASH = /^[0-9a-f]{64}$/;
const fail = () => { throw new TypeError('Ungültige revisionsgebundene STEP-Quelle.'); };

/** Preserve the source selector when replacing a download URL with a server-side read. */
export function stepExportSource(stepPath) {
  const path = String(stepPath || '');
  if (!path.startsWith('/api/asset-objects/')) return null;
  const match = /^\/api\/asset-objects\/([1-9][0-9]*)\/file\/source(?:\?([^#\s\\]*))?$/.exec(path);
  if (!match) return fail();
  const assetObjectId = Number(match[1]);
  if (!Number.isSafeInteger(assetObjectId)) return fail();
  const params = new URLSearchParams(match[2] || '');
  if ([...params.keys()].some(key => !['revision', 'sourceSha256', 'variant', 'v'].includes(key))) return fail();
  if (!params.has('revision')) {
    if (params.has('sourceSha256') || params.has('variant')) return fail();
    return Object.freeze({ assetObjectId });
  }
  const revision = params.get('revision'), hash = params.get('sourceSha256'), variant = params.get('variant');
  if (params.getAll('revision').length !== 1 || !UUID.test(revision || '')
    || (params.has('sourceSha256') && (params.getAll('sourceSha256').length !== 1 || !HASH.test(hash || '')))
    || (params.has('variant') && (params.getAll('variant').length !== 1 || !/^v-[0-9a-f]{64}$/.test(variant || '')))) return fail();
  // A variant selector means: the cut CAD of that published variant, not the source STEP.
  return Object.freeze({ assetObjectId, assetRevisionId: revision, ...(hash === null ? {} : { assetSourceSha256: hash }),
    ...(variant === null ? {} : { assetVariantId: variant }) });
}
